import { interpolate } from "./utils/interpolate.js";
//#region src/core/i18n/translator.ts
/**
* Builds a typed translator from a resolved translation map (typically from `getI18nTranslations`).
*
* @param translations - Merged translation map for the active locale.
* @param locale - BCP 47 tag associated with the map (reserved for future locale-aware behavior).
* @public
*/
function createTranslator(translations, locale) {
	const translate = (input, params) => {
		const options = params;
		const isDescriptor = typeof input !== "string";
		const key = isDescriptor ? input.key : input;
		const translation = translations[key];
		if (translation === void 0 && !isDescriptor && options?.default === void 0) console.warn(`[videojs] Missing translation for "${key}".`);
		const fallback = options?.default;
		const values = options ? { ...options } : void 0;
		if (values) delete values.default;
		const raw = translation ?? (isDescriptor ? input.text : fallback) ?? String(key);
		return interpolate(raw, values);
	};
	return translate;
}
//#endregion
export { createTranslator };

//# sourceMappingURL=translator.js.map